<template>
  <el-table
      v-loading="dataListLoading"
      :data="dataList"
      border
      show-summary
      style="width: 100%;"
  >
    <el-table-column
        type="index"
        label="行号"
        header-align="center"
        align="center"
        width="50"
    ></el-table-column>
    <el-table-column
        prop="sellType"
        label="费用科目"
        header-align="center"
        align="center"
    ></el-table-column>
    <el-table-column
        prop="total"
        label="金额"
        header-align="center"
        align="center"
    ></el-table-column>
  </el-table>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
export default {
  mixins: [mixinViewModule],
  props:{
    params:{
      type:Object,
      default:()=>{
        return {}
      }
    }
  },
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/trade/sell/report/cost',
        getDataListIsPage: false,
        activatedIsNeed: false,
      },
      dataForm: {
        beginDate: '',
        endDate: '',
      },
    }
  },
  watch:{
    params:{
      handler:function(newVal){
        if(!newVal.beginDate||!newVal.endDate){
          return
        }
        this.dataForm={
          ...newVal
        }
        this.getDataList()
      },
      immediate:true,
      deep:true
    }
  },
  methods:{
    refresh(){
      this.getDataList()
    }
  }
}
</script>
